module.exports = __webpack_public_path__ + "img/scale-unbalanced.f133def8.svg";